<template>
  <TemplateView>
    <LoadingAnimation v-show="loadingAnimation" key="loadingAnimation" />
    <v-container v-if="workClientProjectStatistic && workClientProjectStatistic.project">
      <BaseSection>
        <div slot="title" class="d-flex align-center gap-4">
          <div class="mr-2">
            {{ workClientProjectStatistic.project.name }}
          </div>
          <BaseTooltip
            :tooltip="
              workClientProjectStatistic &&
              workClientProjectStatistic.project &&
              workClientProjectStatistic.project.name
            "
          >
            <BaseButton
              icon_only
              width="50"
              height="40"
              default_icon="pages-projects"
              iconColor="white"
              padding="5"
              @click="$router.push({ name: 'ProjectsProjectShow' })"
            />
          </BaseTooltip>
          <BaseTooltip :tooltip="localStorage.translations.pages['projects'].pages.project_reports">
            <BaseButton
              icon_only
              width="50"
              height="40"
              @click="$router.push({ name: 'timeControlShowReports' })"
            >
              <template v-slot:icon>
                <svg
                  width="18"
                  height="24"
                  viewBox="0 0 18 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M3 0C2.20435 0 1.44129 0.31607 0.87868 0.87868C0.31607 1.44129 0 2.20435 0 3V21C0 21.7956 0.31607 22.5587 0.87868 23.1213C1.44129 23.6839 2.20435 24 3 24H15C15.7957 24 16.5587 23.6839 17.1213 23.1213C17.6839 22.5587 18 21.7956 18 21V8.121C17.9998 7.32542 17.6836 6.56248 17.121 6L12 0.879C11.4375 0.316352 10.6746 0.000169912 9.879 0H3ZM6 15C6 14.6022 5.84196 14.2206 5.56066 13.9393C5.27936 13.658 4.89783 13.5 4.5 13.5C4.10218 13.5 3.72064 13.658 3.43934 13.9393C3.15804 14.2206 3 14.6022 3 15V19.5C3 19.8978 3.15804 20.2794 3.43934 20.5607C3.72064 20.842 4.10218 21 4.5 21C4.89783 21 5.27936 20.842 5.56066 20.5607C5.84196 20.2794 6 19.8978 6 19.5V15ZM9 10.5C9.39783 10.5 9.77936 10.658 10.0607 10.9393C10.342 11.2206 10.5 11.6022 10.5 12V19.5C10.5 19.8978 10.342 20.2794 10.0607 20.5607C9.77936 20.842 9.39783 21 9 21C8.60218 21 8.22064 20.842 7.93934 20.5607C7.65804 20.2794 7.5 19.8978 7.5 19.5V12C7.5 11.6022 7.65804 11.2206 7.93934 10.9393C8.22064 10.658 8.60218 10.5 9 10.5ZM15 9C15 8.60218 14.842 8.22064 14.5607 7.93934C14.2794 7.65804 13.8978 7.5 13.5 7.5C13.1022 7.5 12.7206 7.65804 12.4393 7.93934C12.158 8.22064 12 8.60218 12 9V19.5C12 19.8978 12.158 20.2794 12.4393 20.5607C12.7206 20.842 13.1022 21 13.5 21C13.8978 21 14.2794 20.842 14.5607 20.5607C14.842 20.2794 15 19.8978 15 19.5V9Z"
                    fill="#F2F2F2"
                  />
                </svg>
              </template>
            </BaseButton>
          </BaseTooltip>
        </div>
        <div class="d-flex flex-wrap gap-8 f14 fw500">
          <div v-for="i in 2" :key="i" class="d-flex align-center gap-2">
            <svg
              width="18"
              height="20"
              viewBox="0 0 18 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="primary--text text--lighten-5"
            >
              <path
                d="M16 2H15V0H13V2H5V0H3V2H2C1.46957 2 0.960859 2.21071 0.585786 2.58579C0.210714 2.96086 0 3.46957 0 4V18C0 18.5304 0.210714 19.0391 0.585786 19.4142C0.960859 19.7893 1.46957 20 2 20H16C16.5304 20 17.0391 19.7893 17.4142 19.4142C17.7893 19.0391 18 18.5304 18 18V4C18 3.46957 17.7893 2.96086 17.4142 2.58579C17.0391 2.21071 16.5304 2 16 2ZM16 18H2V8H16V18ZM16 6H2V4H16V6Z"
                fill="currentColor"
              />
            </svg>
            <div class="secondary--text">
              {{
                localStorage.translations.pages.statistic_project.text[
                  i === 1 ? 'data-nachala' : 'data-okonchaniya'
                ] + ':'
              }}
            </div>
            <div>
              {{
                formatDate(workClientProjectStatistic.project[i === 1 ? 'start_date' : 'end_date'])
              }}
            </div>
          </div>
        </div>
        <template v-if="!loadingAnimation">
          <template
            v-if="
              (workClientProjectStatistic.periods &&
                Object.keys(workClientProjectStatistic.periods).length) ||
              (workClientProjectStatistic.extra &&
                Object.keys(workClientProjectStatistic.extra).length)
            "
          >
            <TimeControlShowGridEmployee :periods="workClientProjectStatistic.periods" />
            <TimeControlShowTableAllWork :periods="workClientProjectStatistic.periods" />
            <TimeControlShowTableExtra
              v-if="
                workClientProjectStatistic.extra &&
                Object.keys(workClientProjectStatistic.extra).length
              "
              :extra="workClientProjectStatistic.extra"
              :allTime="$formatTime(projectExtraWorkTimeAll())"
            />
            <TimeControlShowTableBlock
              :periods="workClientProjectStatistic.periods"
              :extra="workClientProjectStatistic.extra"
            />
          </template>
          <Plug v-else style="height: 60vh" />
        </template>
      </BaseSection>
      <div class="fixedBtn">
        <BaseTooltip :tooltip="workClientProjectStatistic.project.name">
          <BaseButton
            round
            size="60"
            icon_only
            default_icon="pages-projects"
            icon-color="white"
            @click="$router.push({ name: 'ProjectsProjectShow' })"
          />
        </BaseTooltip>
        <BaseTooltip :tooltip="localStorage.translations.pages['projects'].pages.project_reports">
          <BaseButton
            icon_only
            round
            size="60"
            @click="$router.push({ name: 'timeControlShowReports' })"
          >
            <template v-slot:icon>
              <svg
                width="18"
                height="24"
                viewBox="0 0 18 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M3 0C2.20435 0 1.44129 0.31607 0.87868 0.87868C0.31607 1.44129 0 2.20435 0 3V21C0 21.7956 0.31607 22.5587 0.87868 23.1213C1.44129 23.6839 2.20435 24 3 24H15C15.7957 24 16.5587 23.6839 17.1213 23.1213C17.6839 22.5587 18 21.7956 18 21V8.121C17.9998 7.32542 17.6836 6.56248 17.121 6L12 0.879C11.4375 0.316352 10.6746 0.000169912 9.879 0H3ZM6 15C6 14.6022 5.84196 14.2206 5.56066 13.9393C5.27936 13.658 4.89783 13.5 4.5 13.5C4.10218 13.5 3.72064 13.658 3.43934 13.9393C3.15804 14.2206 3 14.6022 3 15V19.5C3 19.8978 3.15804 20.2794 3.43934 20.5607C3.72064 20.842 4.10218 21 4.5 21C4.89783 21 5.27936 20.842 5.56066 20.5607C5.84196 20.2794 6 19.8978 6 19.5V15ZM9 10.5C9.39783 10.5 9.77936 10.658 10.0607 10.9393C10.342 11.2206 10.5 11.6022 10.5 12V19.5C10.5 19.8978 10.342 20.2794 10.0607 20.5607C9.77936 20.842 9.39783 21 9 21C8.60218 21 8.22064 20.842 7.93934 20.5607C7.65804 20.2794 7.5 19.8978 7.5 19.5V12C7.5 11.6022 7.65804 11.2206 7.93934 10.9393C8.22064 10.658 8.60218 10.5 9 10.5ZM15 9C15 8.60218 14.842 8.22064 14.5607 7.93934C14.2794 7.65804 13.8978 7.5 13.5 7.5C13.1022 7.5 12.7206 7.65804 12.4393 7.93934C12.158 8.22064 12 8.60218 12 9V19.5C12 19.8978 12.158 20.2794 12.4393 20.5607C12.7206 20.842 13.1022 21 13.5 21C13.8978 21 14.2794 20.842 14.5607 20.5607C14.842 20.2794 15 19.8978 15 19.5V9Z"
                  fill="white"
                />
              </svg>
            </template>
          </BaseButton>
        </BaseTooltip>
      </div>
    </v-container>
   <Plug v-else />
  </TemplateView>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import TemplateView from 'components/templates/TemplateView'
import TimeControlShowGridEmployee from 'components/timeControl/show/TimeControlShowGridEmployee'
//import TimeControlShowGantt from 'components/timeControl/show/TimeControlShowGantt'
import TimeControlShowTableAllWork from 'components/timeControl/show/TimeControlShowTableAllWork'
import TimeControlShowTableExtra from 'components/timeControl/show/TimeControlShowTableExtra'
import TimeControlShowTableBlock from 'components/timeControl/show/TimeControlShowTableBlock'
import LoadingAnimation from 'components/LoadingAnimation'
import BaseSection from 'components/base/BaseSection'
import Plug from 'components/Plug'

export default {
  name: 'timeControlShow',
  refs: ['project-grid'],
  components: {
    Plug,
    BaseSection,
    TemplateView,
    //TimeControlShowGantt,
    LoadingAnimation,
    TimeControlShowTableExtra,
    TimeControlShowTableBlock,
    TimeControlShowTableAllWork,
    TimeControlShowGridEmployee,
  },
  data() {
    return {
      projectGridWidth: null,
      periodsShow: false,
      groupsShow: false,
      page: 1,
      limit: 10,
      tasks: {
        data: [],
        links: [],
      },
    }
  },
  computed: {
    ...mapGetters('workClientProject', ['workClientProjectStatistic']),
    ...mapGetters(['loadingAnimation']),
    clientWidth() {
      return this.$vuetify.breakpoint.width
    },
  },
  created() {
    this.onWorkClientProjectStatistic(this.$route.params.id).then(() =>
      this.formatDataGantt(this.workClientProjectStatistic),
    )
  },
  watch: {
    clientWidth() {
      this.getProjectGridWidth()
    },
    periodsShow() {
      this.formatDataGantt(this.workClientProjectStatistic)
    },
    groupsShow() {
      this.formatDataGantt(this.workClientProjectStatistic)
    },
  },
  methods: {
    ...mapActions('workClientProject', ['onWorkClientProjectStatistic']),
    ...mapMutations('workClientProject', ['setWorkClientProjectStatistic']),
    getProjectGridWidth() {
      let target = document.getElementById('project-grid')
      this.projectGridWidth = target ? target.offsetWidth : 0
    },

    onFilterByProject(projectId) {
      if (this.workClientProjectProgress) {
        return this.workClientProjectProgress.filter((i) => i.id === projectId)
      }
    },
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}.${month}.${year}`
    },
    unformatDate(date) {
      if (!date) return null
      const [day, month, year] = date.split('.')
      return `${year}-${month}-${day}`
    },
    projectExtraWorkTimeAll() {
      let time = 0
      if (this.workClientProjectStatistic && this.workClientProjectStatistic.extra) {
        for (let i in this.workClientProjectStatistic.extra) {
          time += Number.parseInt(this.workClientProjectStatistic.extra[i].hours)
        }
      }
      return time
    },
    formatStartEndDate(dateInput) {
      let date = new Date(dateInput)
      let formattedDate =
        (date.getDate() > 9 ? date.getDate() : '0' + date.getDate()) +
        '.' +
        (date.getMonth() > 8 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1)) +
        '.' +
        date.getFullYear()
      return formattedDate
    },
    formatDataGantt(obj) {
      this.tasks.data = []
      let periods = obj.periods
      let project = obj.project
      var projectName = project.name
      let projectId = 'project_' + project.id
      let projectObj = {
        id: projectId,
        text: projectName,
        label: '',
        start_date: this.formatStartEndDate(project.start_date),
        end_date: this.formatStartEndDate(project.end_date),
        color: '#2DB6F5',
        type: 'object',
        plan: { size: null, time: null },
        fact: { size: null, time: null },
        days: {},
      }
      this.tasks.data.push(projectObj)
      const checkProject = (obj) => obj.id === projectId
      const checkGroup = (obj) => obj.id === groupId
      const checkExtraGroup = (obj) => obj.type === 'extraGroup'
      const dateEnd = new Date(new Date().setDate(new Date().getDate() + 1)).setHours(0, 0, 0, 0)
      const addPeriodObj = ({ id, extra, period }) => {
        let periodObj = {
          id,
          text: period.work_type.name,
          is_hourly: period.work_type.is_hourly,
          measure: period.work_type.measure,
          fact: this.$roundNumberToTenths(period.done),
          start_date: this.formatStartEndDate(period.start_date),
          end_date: !extra
            ? this.formatStartEndDate(period.end_date)
            : this.formatStartEndDate(
                new Date(period.end_date) < new Date(dateEnd) ? period.end_date : dateEnd,
              ),
          color: !extra ? '#F2994A' : '#f4f4f400',
          progress: daysLeft / daysTotal,
          type: 'period',
          days: {},
          parent: !extra ? null : 'extra',
        }
        if (!extra) {
          periodObj.plan = this.$roundNumberToTenths(period.planned_work)
          this.tasks.data[this.tasks.data.findIndex(checkProject)].plan[
            periodObj.is_hourly ? 'time' : 'size'
          ] += periodObj.plan
        } else {
          this.tasks.data[this.tasks.data.findIndex(checkExtraGroup)].fact[
            periodObj.is_hourly ? 'time' : 'size'
          ] += periodObj.fact
        }
        this.tasks.data[this.tasks.data.findIndex(checkProject)].fact[
          periodObj.is_hourly ? 'time' : 'size'
        ] += periodObj.fact

        if (this.periodsShow) {
          this.tasks.data.push(periodObj)
        }
      }
      const addGroupObj = ({ id, extra, employee, period }) => {
        let groupObj = {
          id,
          text: employee.work_group.name,
          work_name: period.work_type.name,
          fact: this.$roundNumberToTenths(employee.done),
          color: '#F2994A',
          start_date: periodStart,
          end_date: !extra
            ? periodEnd
            : this.formatStartEndDate(
                new Date(project.end_date) < new Date(dateEnd) ? project.end_date : dateEnd,
              ),
          parent: !extra
            ? this.periodsShow
              ? periodId
              : null
            : this.periodsShow
            ? extraPeriodId
            : 'extra',
          is_hourly: period.work_type.is_hourly,
          measure: period.work_type.measure,
          type: 'group',
          employees_count: 1,
          progress: daysLeft / daysTotal,
          days: {},
        }
        if (!extra) {
          groupObj.plan = this.$roundNumberToTenths(period.planned_work / period.employees_count)
        }
        this.tasks.data.push(groupObj)
      }
      const groupObjReady = ({ period, employeeData, checkGroup }) => {
        const groupObjReady = this.tasks.data[this.tasks.data.findIndex(checkGroup)]
        groupObjReady.employees_count += 1
        groupObjReady.plan += this.$roundNumberToTenths(
          period.planned_work / period.employees_count,
        )
        groupObjReady.fact += this.$roundNumberToTenths(employeeData.done)
        groupObjReady.progress = daysLeft / daysTotal
      }
      const addEmployeeObj = ({ extra, employeeData, period, employeeKey }) => {
        let employeeObj = {
          id: employeeData.work_group
            ? groupId + '-employee_' + employeeKey
            : (extra ? extraPeriodId : periodId) + '-employee_' + employeeKey,
          text: employeeData.first_name + ' ' + employeeData.last_name,
          work_name: period.work_type.name,
          last_name: employeeData.last_name,
          first_name: employeeData.first_name,
          start_date: periodStart,
          end_date: periodEnd,
          color: !extra ? '#F2994A' : '#f4f4f400',
          photo: employeeData.photo,
          is_hourly: period.work_type.is_hourly,
          measure: period.work_type.measure,
          fact: this.$roundNumberToTenths(employeeData.done),
          days: employeeData.days,
          parent:
            this.groupsShow && employeeData.work_group.id
              ? groupId
              : this.periodsShow
              ? extra
                ? extraPeriodId
                : periodId
              : extra
              ? 'extra'
              : null,
          type: 'employee',
          group: employeeData.work_group.id && (this.groupsShow || this.periodsShow) ? true : false,
        }
        if (!extra) {
          employeeObj.plan = this.$roundNumberToTenths(period.planned_work / period.employees_count)
        }
        this.tasks.data.push(employeeObj)
      }
      const addCompleteWorkData = ({
        checkGroup,
        checkProject,
        checkPeriod,
        checkExtraGroup,
        employeeData,
        period,
      }) => {
        let groupObjReady = this.tasks.data[this.tasks.data.findIndex(checkGroup)]
        let objPeriodReady = this.tasks.data[this.tasks.data.findIndex(checkPeriod)]
        let objProjectReady = this.tasks.data[this.tasks.data.findIndex(checkProject)]
        for (let dayIndex in employeeData.days) {
          if (objProjectReady.days[dayIndex]) {
            objProjectReady.days[dayIndex][period.work_type.is_hourly ? 'time' : 'size'] +=
              employeeData.days[dayIndex]
          } else {
            objProjectReady.days[dayIndex] = { size: null, time: null }
            objProjectReady.days[dayIndex][period.work_type.is_hourly ? 'time' : 'size'] =
              employeeData.days[dayIndex]
          }
          if (groupObjReady) {
            if (groupObjReady.days[dayIndex]) {
              groupObjReady.days[dayIndex] += employeeData.days[dayIndex]
            } else {
              groupObjReady.days[dayIndex] = employeeData.days[dayIndex]
            }
          }
          if (objPeriodReady) {
            if (objPeriodReady.days[dayIndex]) {
              objPeriodReady.days[dayIndex] += employeeData.days[dayIndex]
            } else {
              objPeriodReady.days[dayIndex] = employeeData.days[dayIndex]
            }
          }
          if (checkExtraGroup) {
            let objExtraGroup = this.tasks.data[this.tasks.data.findIndex(checkExtraGroup)]
            if (objExtraGroup.days[dayIndex]) {
              objExtraGroup.days[dayIndex][period.work_type.is_hourly ? 'time' : 'size'] +=
                employeeData.days[dayIndex]
            } else {
              objExtraGroup.days[dayIndex] = { size: null, time: null }
              objExtraGroup.days[dayIndex][period.work_type.is_hourly ? 'time' : 'size'] =
                employeeData.days[dayIndex]
            }
          }
        }
      }
      for (let periodKey in periods) {
        let period = periods[periodKey]
        const checkPeriod = (obj) => obj.id === periodId
        if (typeof period == 'object' && period.is_extra == 0) {
          var periodId = projectId + '-period_' + periodKey
          var periodStart = this.formatStartEndDate(period.start_date)
          var periodEnd = this.formatStartEndDate(period.end_date)
          const dateNow = new Date().toISOString().split('T')[0]
          const timeDiff = new Date(period.end_date) - new Date(period.start_date)
          var daysTotal = timeDiff / (1000 * 60 * 60 * 24)
          var daysLeft = (new Date(dateNow) - new Date(period.start_date)) / (1000 * 60 * 60 * 24)
          addPeriodObj({ period, id: periodId, extra: false })

          for (let employeeKey in period.employees) {
            let employeeData = period.employees[employeeKey]
            var groupId = employeeData.work_group
              ? periodId + '-group_' + employeeData.work_group.id
              : null
            if (typeof employeeData == 'object' && employeeKey) {
              if (this.groupsShow && employeeData.work_group.id) {
                if (this.tasks.data.findIndex(checkGroup) === -1) {
                  addGroupObj({
                    id: groupId,
                    extra: false,
                    period,
                    employee: employeeData,
                  })
                } else {
                  groupObjReady({ period, employeeData, checkGroup })
                }
              }
              addEmployeeObj({ extra: false, employeeData, period, employeeKey })
              if (typeof employeeData.days === 'object') {
                addCompleteWorkData({
                  checkGroup,
                  checkProject,
                  checkPeriod,
                  employeeData,
                  period,
                })
              }
            }
          }
        } else if (typeof period == 'object' && period.is_extra == 1 && period.done > 0) {
          var extraPeriodId = 'extra-period_' + periodKey
          var periodStart = this.formatStartEndDate(period.start_date)
          var periodEnd = this.formatStartEndDate(period.end_date)
          const dateNow = new Date().toISOString().split('T')[0]
          const timeDiff = new Date(period.end_date) - new Date(period.start_date)
          var daysTotal = timeDiff / (1000 * 60 * 60 * 24)
          var daysLeft = (new Date(dateNow) - new Date(period.start_date)) / (1000 * 60 * 60 * 24)
          if (this.tasks.data.findIndex(checkExtraGroup) === -1) {
            let extraGroupObj = {
              type: 'extraGroup',
              id: 'extra',
              text: this.localStorage.translations.pages.statistic_project.tables[
                'dopolnitelnye-resursy'
              ],
              fact: { size: null, time: null },
              start_date: this.formatStartEndDate(period.start_date),
              end_date: this.formatStartEndDate(
                new Date(period.end_date) < new Date(dateEnd) ? period.end_date : dateEnd,
              ),
              color: '#f4f4f400',
              days: {},
            }
            this.tasks.data.push(extraGroupObj)
          }
          const checkPeriodExtra = (obj) => obj.id === extraPeriodId
          addPeriodObj({ period, id: extraPeriodId, extra: true })

          if (
            new Date(this.tasks.data[this.tasks.data.findIndex(checkExtraGroup)].start_date) >=
            new Date(period.start_date)
          ) {
            this.tasks.data[this.tasks.data.findIndex(checkExtraGroup)].start_date =
              this.formatStartEndDate(period.start_date)
          }
          if (
            typeof this.tasks.data[this.tasks.data.findIndex(checkExtraGroup)].end_date ===
              'string' &&
            new Date(
              this.unformatDate(
                this.tasks.data[this.tasks.data.findIndex(checkExtraGroup)].end_date,
              ),
            ) <= new Date(period.end_date)
          ) {
            this.tasks.data[this.tasks.data.findIndex(checkExtraGroup)].end_date =
              this.formatStartEndDate(
                new Date(period.end_date) < new Date(dateEnd) ? period.end_date : dateEnd,
              )
          }
          for (let employeeKey in period.employees) {
            let employeeData = period.employees[employeeKey]
            var groupId = employeeData.work_group
              ? extraPeriodId + '-group_' + employeeData.work_group.id
              : null
            if (typeof employeeData == 'object' && employeeKey) {
              if (this.groupsShow && employeeData.work_group.id) {
                if (this.tasks.data.findIndex(checkGroup) === -1) {
                  addGroupObj({
                    id: groupId,
                    extra: true,
                    period,
                    employee: employeeData,
                  })
                } else {
                  groupObjReady({ period, employeeData, checkGroup })
                }
              }
              addEmployeeObj({ extra: true, employeeData, period, employeeKey })
              if (typeof employeeData.days === 'object') {
                addCompleteWorkData({
                  checkGroup,
                  checkProject,
                  checkPeriod: checkPeriodExtra,
                  checkExtraGroup,
                  employeeData,
                  period,
                })
              }
            }
          }
        }
        if (this.$refs.gantt) this.$refs.gantt.updateGantt()
      }
    },
  },
  destroyed() {
    this.setWorkClientProjectStatistic()
  },
}
</script>
